export const activityStaff = ["Principal","Course Leader","Parent Liaison","Parent Liaison1"]
export const activityJapanStaff = ["Principal","Course Leader","Parent Liaison","Parent Liaison1"]